module.exports = __webpack_public_path__ + "img/1.73a89450.png";